import * as types from './mutations-types'

export default {
  [types.SEARCH_MEMBER_RESULT] (state, data) {
    state.searchMemberResult = data.dataList
  },
  [types.COUPONS_INFO] (state, data) {
    state.couponsInfo = data.map(item => {
      item.times = null
      item.price = null
      item.showRemarks = false
      return item
    })
  },
  [types.PENDING_APPROVAL_COUPONS] (state, data) {
    state.pendingApprovalCoupons = data
  },
  [types.OUTSIDE_THE_STORE_APPLICATION_TYPE_OPTIONS] (state, data) {
    state.outsideTheStoreApplicationTypeOptions = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/card-operation/store/mutations.js